import type { BuildAndBuyDispatchType } from "../../redux/store";
import { useBnbSelector } from "../../redux/store";
import CarDataConsolidator, {
    COLOUR,
    UPHOLSTERY,
    WHEEL,
} from "../../../../shared-logic/utils/classes/CarDataConsolidator";
import type { PersonalisationItemType, PersonalizationType } from "../../../../../common-deprecated/types/CommonTypes";
import { setPersonalization } from "../../redux/actions/BasketActions";
import { setActivePersonalisation } from "../../../../../common-deprecated/redux/actions/UtilActions";
import { showNextGenInteriorDisclaimer } from "../../utils/settings/bnbSettingUtils";
import { useDispatch } from "../../../../../shared-logic/redux/store";

export type UsePersonalizationReturnType = {
    showNextGenInteriorDisclaimer: boolean;
    onSwitch: (personalization: PersonalizationType) => void;
    options: PersonalisationItemType[];
    selectItem: (itemType: PersonalizationType, item: PersonalisationItemType) => void;
    value: PersonalisationItemType;
};

const usePersonalization = (): UsePersonalizationReturnType => {
    const activePersonalization = useBnbSelector((state) => state.utils.activePersonalization);
    const wheels = useBnbSelector((state) => state.items.wheels);
    const colours = useBnbSelector((state) => state.items.colours);
    const packs = useBnbSelector((state) => state.items.packs);
    const upholsteries = useBnbSelector((state) => state.items.upholsteries);
    const equipmentUpholsteries = useBnbSelector((state) => state.items.equipmentUpholsteries);
    const basket = useBnbSelector((state) => state.basket);
    const car = useBnbSelector((state) => state.car);
    const showNextGenInteriorDisclaimerSetting = useBnbSelector((state) =>
        showNextGenInteriorDisclaimer(state.bnbSettings, state.commonSettings, state.car.model.id),
    );
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    let personalisationOptions: PersonalisationItemType[] = [];
    switch (activePersonalization) {
        case UPHOLSTERY:
            // Show both the regular upholsteries as accessory upholsteries in the list
            personalisationOptions = CarDataConsolidator.getUpholsteries(upholsteries, equipmentUpholsteries, basket);
            break;
        case WHEEL:
            personalisationOptions = CarDataConsolidator.getWheels(wheels, basket, packs);

            break;
        case COLOUR:
            personalisationOptions = CarDataConsolidator.getColours(colours, basket);
            break;
    }

    const personalizationValue = CarDataConsolidator.getPersonalizationValue(activePersonalization, basket, car);

    return {
        options: personalisationOptions,
        value: personalizationValue,
        showNextGenInteriorDisclaimer: showNextGenInteriorDisclaimerSetting,
        onSwitch: (personalization: PersonalizationType) => {
            dispatch(setActivePersonalisation(personalization));
        },
        selectItem: (itemType: PersonalizationType, item: PersonalisationItemType) => {
            setPersonalization(dispatch, item, itemType);
        },
    };
};

export default usePersonalization;
